import {
    XLRG_IMAGE,
    LRG_IMAGE,
    MED_IMAGE,
    SML_IMAGE,
    XSML_IMAGE,
    DPR_1
} from '../../utils/constants';
import { MIXPANEL_PAGE_NAME, BIGQUERY_PAGE_NAME } from '../../utils/biEvents/constants';
import { imgPathWithTransforms, imgSrcSetFull } from '../../utils/image';

const XSMALL_WIDTH = 360;
const SMALL_WIDTH = 600;
const MEDIUM_WIDTH = 900;
const LARGE_WIDTH = 600;
const XLARGE_WIDTH = 700;

const imgPath = '089e3bb9352f90802ad07ad9f6a4a450-1599517407052/selling-proposition-still-1400-x1.png';

export const pictureData = [
    {
        srcSet: imgSrcSetFull({ width: XLARGE_WIDTH, img: imgPath }),
        media: XLRG_IMAGE
    },
    {
        srcSet: imgSrcSetFull({ width: LARGE_WIDTH, img: imgPath }),
        media: LRG_IMAGE
    },
    {
        srcSet: imgSrcSetFull({ width: MEDIUM_WIDTH, img: imgPath }),
        media: MED_IMAGE
    },
    {
        srcSet: imgSrcSetFull({ width: SMALL_WIDTH, img: imgPath }),
        media: SML_IMAGE
    },
    {
        srcSet: imgSrcSetFull({ width: XSMALL_WIDTH, img: imgPath }),
        media: XSML_IMAGE
    }
];

export const imgSrc = imgPathWithTransforms({ width: XLARGE_WIDTH, dpr: DPR_1, img: imgPath });

export const videoUrl = 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/vmvv3czyk2ifedefkau7';
export const sourceInfo = {
    videoName: 'Fiverr intro',
    mixpanel: {
        pageName: MIXPANEL_PAGE_NAME
    },
    bigQuery: {
        pageName: BIGQUERY_PAGE_NAME
    }
};
export { default as subtitles } from '../../assets/SellingProposition/subtitles';
